import styled, { css } from "styled-components";
export const StyledMainItemWrapper = styled.div`
  display: flex;
  flex: 1;
  cursor: pointer;
  position: relative;
  flex-direction: column;
`;

export const StyledItem = styled.div<{ $active: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $active }) => {
    if ($active) {
      return "rgba(0, 0, 0)";
    }
    return "rgba(146, 146, 146)";
  }};
  background: ${({ $active }) => {
    if ($active) {
      return "rgba(242, 242, 242)";
    } else {
      return "transparent";
    }
  }};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ExtendedStyledItem = styled.div<{ active: boolean }>`
  display: inline-flex;
  flex: 1;
  gap: 8px;
  justify-content: start;
  align-items: center;
  font-family: var(--sinch-ref-typography-font-family-main);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;

  ${({ active }) =>
    active &&
    css`
      font-size: 18px;
      font-weight: 500;
    `}
`;

export const SubMenuAnimation = styled.div<{
  isOpen: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: ${({ isOpen }) => (isOpen ? "auto" : "0")};
  overflow: hidden;
  transition: height 0.3s;
`;

export const StyledItemWrapper = styled.div`
  display: inline-flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;

  & > a {
    color: unset;

    &:focus-visible {
      outline: none;
    }
  }
`;

export const StyledExpandButton = styled.button`
  width: 40px;
  height: 40px;
`;

export const StyledLabel = styled.div<{ $active: boolean }>`
  border-radius: 8px;
  color: #1b1b1b;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  ${({ $active }) =>
    $active &&
    css`
      font-weight: 500;
      font-size: 18px;
    `};
`;

export const StyledItemText = styled.span`
  color: var(--sinch-comp-color-menu-option-color-default-border-active);
`;

export const StyledLinkWrapper = styled.div<{
  $active: boolean;
  withPadding?: boolean;
}>`
  & > a {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    width: 100%;
    ${({ withPadding }) =>
      withPadding &&
      css`
        padding: 10px 0 10px 48px;
      `}
  }
`;
